import { render, staticRenderFns } from "./UserRoutes.vue?vue&type=template&id=f0f1b5e8&"
import script from "./UserRoutes.vue?vue&type=script&lang=js&"
export * from "./UserRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports